<template>
    <v-modal-slot id="show-entities-modal"
                  size="xl"
                  @closed="closeModal">
        <template v-slot:modal-title>
            Información de la entidad
        </template>

        <template v-slot:modal-content>
            <template v-if="loading">
                <div class="loader-container">
                    <div class="loader"></div>
                </div>
            </template>
            <template v-else>
                <div class="row">
                    <div class="col-5">
                        <div><strong>NIF:</strong></div>
                        <p>{{ entity_info.nif }}</p>
                    </div>
    
                    <div class="col-7">
                        <div><strong>Nombre corto:</strong></div>
                        <p>{{ entity_info.short_name }}</p>
                    </div>
                </div>
    
                <div class="row">
                    <div class=" col-12">
                        <div><strong>Nombre:</strong></div>
                        <p>{{ entity_info.name }}</p>
                    </div>
                </div>
    
                <div class="row">
                    <div class="form-group" :class="field.class" v-for="field in fields">
                        <div><strong>{{ field.display_name }}:</strong></div>
                        <p>{{ entity_info[field.name] ? entity_info[field.name] : '-' }}</p>
                    </div>
                </div>
            </template>
        </template>
    </v-modal-slot>
</template>

<script>
import VModal from "../../general/VModal";
import VModalSlot from "../../general/VModalSlot";

import { getEntity } from "../../../helpers/requests/RequestsEntities";

export default {
    name: "EntititesListShowModal",
    components: {VModalSlot, VModal},
    props: {
        entity: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            fields: [],
            entityFields: [],
            entity_info: this.entity,
            loading: false            
        }
    },
    mounted() {
        this.fields = require('../../../config/form_fields.json').entities;
        this.getEntityInformation();
    },
    methods: {
        closeModal() {
            this.$emit('closed');
        },
        async getEntityInformation() {
            this.loading = true;
            this.entity_info = await getEntity(this.entity.id);
            this.loading = false;
        }
    }
}
</script>
